// Banks Vuex

import state from './dividendStates.js'
import * as getters from './dividendGetters.js'
import * as mutations from './dividendMutations.js'
import * as actions from './dividendActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
